import React, {Component} from "react";
import {Avatar, Col, Icon, message, Row, Select, Table, Button} from "antd";
import "./main-page.less";
import LineEcharts from "./line-echarts";
import {reqOrder, reqWarnings, reqWayOrder} from "../../api";
import WarningModal from './warning-modal';
import authorizeBase from "../../components/authorize/authorizeBase";
import LinkButton from '../../components/link-button'
const AuthButton = authorizeBase(Button);

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: 'https://at.alicdn.com/t/font_1568176_vtggzhmtr1.js',
});
const {Option} = Select;
class MainPage extends Component {
    state = {
        orderList: [],
        pageNum: 1,
        total: 0,
        optType: 'pass-transport',
        days: '30',
        visible: false,
    };
    getOrder = async () => {
        let result = await reqOrder();
        if (result.code === 200) {
            this.setState(result.data);
        }
    };
    getWayOrder = async () => {
        let result = await reqWayOrder();
        if (result.code === 200) {
            this.setState(result.data);
        }
    };
    getWarnings = async (po) => {
        let result = await reqWarnings(po);
        if (result.code === 200) {
            this.setState({
                orderList: result.data.rows,
                total: result.data.total,
            })
        } else {
            message.error(result.message)
        }
    };
    showModal = (recordId) => {
        this.setState({
            visible: true,
            recordId: recordId,
        });
    };

    componentDidMount() {
        this.getOrder();
        this.getWayOrder();
        this.getWarnings({pageNum: this.state.pageNum, days: this.state.days,});
    }

    render() {
        const {orderList, total} = this.state;
        const columns = [
            {
                title: '报警日期',
                dataIndex: 'warningDt',
            },
            {
                title: '报警等级',
                dataIndex: 'level',
                render: (text, record, index) => {
                    if (text == '1') {
                        return '一般';
                    } else if (text == '2') {
                        return '严重';
                    } else {
                        return '';
                    }
                }
            },
            {
                title: '订单编号',
                dataIndex: 'orderNo',
            },
            {
                title: '集装箱号',
                dataIndex: 'containerNo',
            },
            {
                title: '行程计划',
                dataIndex: 'originCity',
                render: (text, record, index) => {
                    return (text ? text : '') + ' 至 ' + (record.destinationCity ? record.destinationCity : '');
                }
            },
            {
                title: '发车日期',
                dataIndex: 'collectDt',
            },
            {
                title: 'GPS编号',
                dataIndex: 'deviceid'
            }, {
                title: '报警内容',
                dataIndex: 'content'
            }, {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => (
                    <span><LinkButton onClick={() => {
                        this.showModal(record.id);
                    }}>备注</LinkButton></span>
                )
            },
        ];


        return (
            <div className='home-page'>
                <WarningModal visible={this.state.visible} recordId={this.state.recordId}/>
                <div className='summarizing'>
                    <div className="summarizing-title">
                        数据汇总
                    </div>
                    <div>
                        <Row>
                            <Col span={6} style={{borderRight: '1px solid #ededed'}}
                                 className='summarizing-item'><Avatar size="large" className='summarizing-avatar'>
                                <IconFont type="icon-layer"/>
                            </Avatar>
                                <div className='summarizing-data'>
                                    <div className='summar-info'>累计订单量</div>
                                    <div>{this.state.totalNum}</div>
                                </div>
                            </Col>
                            <Col span={6} style={{borderRight: '1px solid #ededed'}}
                                 className='summarizing-item'><Avatar size="large" className='summarizing-avatar'>
                                <IconFont type="icon-wait"/>
                            </Avatar>
                                <div className='summarizing-data'>
                                    <div className='summar-info'>未发货订单量</div>
                                    <div>{this.state.waitNum}</div>
                                </div>
                            </Col>
                            <Col span={6} style={{borderRight: '1px solid #ededed'}}
                                 className='summarizing-item'><Avatar size="large" className='summarizing-avatar'>
                                <IconFont type="icon-train"/>
                            </Avatar>
                                <div className='summarizing-data'>
                                    <div className='summar-info'>在途订单量</div>
                                    <div>{this.state.wayNum}</div>
                                </div>
                            </Col>
                            <Col span={6} className='summarizing-item'><Avatar size="large"
                                                                               className='summarizing-avatar'>
                                <IconFont type="icon-history"/>
                            </Avatar>
                                <div className='summarizing-data'>
                                    <div className='summar-info'>历史订单量</div>
                                    <div>{this.state.historyNum}</div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="transit-information">
                    <div className="transit-information-title">
                        在途信息概况
                    </div>
                    <div className="transit-information-content">
                        <div className="i-survey-box">
                            <div className="iteam start">
                                <div className="info-box">
                                    <div>起始地</div>
                                    <div className="circular"></div>
                                    <div className="line"></div>
                                </div>
                            </div>
                            <div className="iteam flex-list">
                                <div className="number-box">
                                    <div className="iconfont">
                                        <IconFont type="icon-shenhe1"/>&nbsp;国内段
                                    </div>
                                    <div className="number">{this.state.collectNum}</div>
                                </div>
                                <div className="info-box">
                                    <div style={{color: '#F6BB42'}}>转运铁路干线</div>
                                    <div className="circular" style={{
                                        background: '#FCE3B0',
                                        border: '2px solid #F6BB42'
                                    }}></div>
                                    <div className="line" style={{background: '#F6BB42'}}></div>
                                </div>
                            </div>
                            <div className="iteam flex-list">
                                <div className="number-box">
                                    <div className="iconfont">
                                        <IconFont type="icon-icon-life-train"/>
                                    </div>
                                    <div className="number">{this.state.transportNum}</div>
                                </div>
                                <div className="info-box">
                                    <div style={{color: '#8CC152'}}>多斯特克</div>
                                    <div className="circular" style={{
                                        background: '#CBF69B',
                                        border: '2px solid #8CC152'
                                    }}></div>
                                    <div className="line" style={{background: '#8CC152'}}></div>
                                </div>
                            </div>
                            <div className="iteam flex-list">
                                <div className="number-box">
                                    <div className="iconfont">
                                        <IconFont type="icon-icon-life-train"/>
                                    </div>
                                    <div className="number">{this.state.dstkArriveNum}</div>
                                </div>
                                <div className="info-box">
                                    <div style={{color: '#3BAFDA'}}>布列斯特</div>
                                    <div className="circular" style={{
                                        background: '#84D1EE',
                                        border: '2px solid #3BAFDA'
                                    }}></div>
                                    <div className="line" style={{background: '#3BAFDA'}}></div>
                                </div>
                            </div>
                            <div className="iteam flex-list">
                                <div className="number-box">
                                    <div className="iconfont">
                                        <IconFont type="icon-icon-life-train"/>
                                    </div>
                                    <div className="number">{this.state.arriveBrestNum}</div>
                                </div>
                                <div className="info-box">
                                    <div style={{color: '#967ADC'}}>马拉</div>
                                    <div className="circular" style={{
                                        background: '#D0BEFE',
                                        border: '2px solid #967ADC'
                                    }}></div>
                                    <div className="line" style={{background: '#967ADC'}}></div>
                                </div>
                            </div>
                            <div className="iteam flex-list">
                                <div className="number-box">
                                    <div className="iconfont">
                                        <IconFont type="icon-icon-life-train"/>
                                    </div>
                                    <div className="number">{this.state.arriveMalaNum}</div>
                                </div>
                                <div className="info-box">
                                    <div style={{color: '#ededed'}}>目的地</div>
                                    <div className="circular" style={{
                                        background: '#fff',
                                        border: '2px solid #ededed'
                                    }}></div>
                                    <div className="line" style={{background: '#ededed'}}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="echarts-information">
                    <div className="echarts-information-title">
                        近30天订单时效分析
                        <Select defaultValue="pass-transport" style={{width: 200, float: 'right'}}
                                onChange={e => {
                                    this.setState({optType: e});
                                }}>
                            <Option value="pass-transport">赣州国际港站-阿拉山口</Option>
                            <Option value="transport-dstkArrive">阿拉山口-到达多斯特克</Option>
                            <Option value="dstkOut-arriveBrest">多斯特克出发-到达布列斯特</Option>
                            <Option value="arriveBrest-arriveMala">布列斯特出发-到达马拉舍维奇</Option>
                            <Option value="leaveMala-destination">马拉舍维奇出发-到达目的地</Option>
                            <Option value="pass-destination">赣州国际港站-目的地</Option>
                        </Select>
                    </div>
                    <div className="echarts-information-content">
                        <LineEcharts optType={this.state.optType} history={this.props.history}/>
                    </div>
                </div>

                {/*<div className="warning-info">
                    <div className="warning-info-title">
                        预警信息列表
                        <Select defaultValue="近30天" style={{width: 200, float: 'right'}}
                                onChange={e => {
                                    this.getWarnings({pageNum: this.state.pageNum, days: e,});
                                    this.setState({days: e});
                                }}>
                            <Option value="30">近30天</Option>
                            <Option value="60">近60天</Option>
                            <Option value="180">近半年</Option>
                            <Option value="365">近一年</Option>
                            <Option value="">全部</Option>
                        </Select>
                    </div>
                    <div className="warning-info-content" style={{height: 'auto'}}>
                        <Table
                            columns={columns}
                            bordered
                            dataSource={orderList}
                            rowKey='id'
                            pagination={{
                                current: this.state.pageNum,
                                total: total,
                                showQuickJumper: true,
                                onChange: (pageNum, pageSize) => {
                                    this.getWarnings({pageNum: pageNum, days: this.state.days,});
                                    this.setState({pageNum: pageNum, visible:false});
                                },
                            }}
                            size="middle"
                        />
                    </div>
                </div>*/}

            </div>
        )
    }
}
export default MainPage